export function toSuperScript(string: string) {
  let data = string.replace("®", "<sup>&reg;</sup>");
  return data;
}
